
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Button } from "@/components/ui/button";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useTranslations } from "use-intl";

const Payments = () => {
  const t = useTranslations("consultantPayments.page");
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tab = searchParams.get('tab') || 'payables';

  const handleTabChange = (value: string) => {
    const path = value === 'payables' ? '/account-payables/payments' : '/account-receivables';
    navigate(path);
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold tracking-tight pt-2 mb-6">{t("title")}</h1>
        <div className="space-x-4">
          <Button asChild>
            <Link to="/account-payables/payments">{t("payables")}</Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/account-receivables">{t("receivables")}</Link>
          </Button>
        </div>
      </div>
      
      <Tabs value={tab} onValueChange={handleTabChange} className="w-full">
        <TabsList className="mb-4">
          <TabsTrigger value="payables">{t("payables")}</TabsTrigger>
          <TabsTrigger value="receivables">{t("receivables")}</TabsTrigger>
        </TabsList>
        
        <TabsContent value="payables" className="space-y-4">
          <div className="text-center p-8">
            <h2 className="text-xl font-semibold mb-4">{t("redirectPayables")}</h2>
            <p className="mb-4">{t("viewPayables")}</p>
            <Button asChild>
              <Link to="/account-payables/payments">{t("goPayables")}</Link>
            </Button>
          </div>
        </TabsContent>
        
        <TabsContent value="receivables">
          <div className="text-center p-8">
            <h2 className="text-xl font-semibold mb-4">{t("redirectReceivables")}</h2>
            <p className="mb-4">{t("viewReceivables")}</p>
            <Button asChild>
              <Link to="/account-receivables">{t("goReceivables")}</Link>
            </Button>
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default Payments;
